import {Palier} from "@/ts/interface/detailOffre";

export function getPositionCurrentPalier(
  paliers: Palier[],
  engagement: number,
): number {
  const nbUniteEngage = engagement;
  const currentPalier = paliers.findLast(
    parlier => parlier.nombre <= nbUniteEngage,
  );

  return currentPalier?.position || 0;
}
